import { render, staticRenderFns } from "./CollapsableCaret.vue?vue&type=template&id=65f1a16c"
import script from "./CollapsableCaret.vue?vue&type=script&lang=js"
export * from "./CollapsableCaret.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports